import { Controller } from "@hotwired/stimulus"
import { Swiper } from "swiper"
import { Navigation } from "swiper/modules"

// Lightweight responsive carousel for the marketplace "Featured" row.
export default class extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [Navigation],
      slidesPerView: 1.2,
      spaceBetween: 16,
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        576: { slidesPerView: 2.2 },
        768: { slidesPerView: 3 },
        992: { slidesPerView: 4 },
      },
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }
}
